.row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 4px;
	padding-bottom: 4px;
}

.left {
	flex: 1 0 auto;
}

.right {
	flex: initial;
}
